class ProductUpsell {
  constructor() {
    this.upsellButtons = document.querySelectorAll(".product-upsell .add-flavor-button");
    this.mainAddToCartForm = document.querySelector('form[action="/cart/add"]');
    this.customAddToCartButton = document.querySelector('[id^="CustomProductSubmitButton-"]');
    this.selectedUpsells = new Map();
    this.isAddingToCart = false;
    this.routineItems = document.querySelectorAll(".product-routine-item");
    this.displayMode = window.UPSELL_DISPLAY_MODE || "am-pm";
    this.selectedRoutine = this.displayMode;
    this.subscriptionItems = document.querySelectorAll(".product-subscription-item");
    this.selectedSubscription = "subscription";
    this.additionalUpsellButtons = document.querySelectorAll(".add-additional-product-button");
    this.selectedAdditionalProducts = new Map();
    this.scrollTimeout = null;
    this.lastScrollTime = 0;
    this.scrollThreshold = 300;
    this.isWheelScrolling = false;
  }
  init() {
    const hasRoutineContainer = document.querySelector('.product-routine-container');
    const hasUpsellSection = document.querySelector('.product-upsell');
    const hasSubscriptionContainer = document.querySelector('.product-subscription-container');
    if (!hasRoutineContainer && !hasUpsellSection && !hasSubscriptionContainer) {
      setTimeout(() => this.init(), 100);
      return;
    }
    this.initEventListeners();
    this.setDefaultSelections();
    if (this.customAddToCartButton) {
      this.initCustomButtonListener();
      this.updateAddToCartButtonAvailability();
    }
    this.updatePricingDisplays();
    this.updateUpsellOptions();
    this.flavorCards = document.querySelectorAll(".flavor-card");
    if (this.flavorCards.length) {
      this.flavorCards.forEach((card) => {
        card.addEventListener("click", (e) => {
          if (e.target.closest(".add-flavor-button")) return;
          this.handleFlavorCardClick(card);
        });
      });
    }
    this.initFlavorGalleryModal();
    this.initAdditionalUpsellProducts();
  }
  setDefaultSelections() {
    if (this.displayMode === "am-pm" && this.routineItems.length > 0) {
      const amPmRoutine = document.querySelector(".product-routine-item.am-pm-routine");
      if (amPmRoutine) {
        amPmRoutine.classList.add("selected", "am-pm-selected");
      }
    }
    if (this.subscriptionItems.length > 0) {
      const subscriptionItem = document.querySelector(".product-subscription-item.subscription-1-month");
      if (subscriptionItem) {
        subscriptionItem.classList.add("selected");
      }
    }
    this.updateInfoBoxVisibility();
    this.updatePurchaseOptionSVGs();
    this.updateUpsellOptions();
  }
  initEventListeners() {
    if (this.upsellButtons.length) {
      this.upsellButtons.forEach((button) => {
        button.addEventListener("click", this.handleUpsellButtonClick.bind(this));
      });
    }
    if (this.routineItems.length) {
      this.routineItems.forEach((item) => {
        item.addEventListener("click", this.handleRoutineSelection.bind(this));
      });
    }
    // Add click event listeners to subscription selection items
    if (this.subscriptionItems.length) {
      this.subscriptionItems.forEach((item) => {
        item.addEventListener("click", this.handleSubscriptionSelection.bind(this));
      });
    }
  }
  handleRoutineSelection(event) {
    const routineItem = event.currentTarget;
    // Remove selected class from all routine items
    this.routineItems.forEach((item) => {
      item.classList.remove("selected", "am-selected", "pm-selected");
    });
    // Add selected class to clicked item
    routineItem.classList.add("selected");
    // Update selected routine and add individual classes
    if (routineItem.classList.contains("am-pm-routine")) {
      this.selectedRoutine = "am-pm";
      routineItem.classList.add("am-pm-selected");
    } else if (routineItem.classList.contains("am-routine")) {
      this.selectedRoutine = "am";
      routineItem.classList.add("am-selected");
    } else if (routineItem.classList.contains("pm-routine")) {
      this.selectedRoutine = "pm";
      routineItem.classList.add("pm-selected");
    }
    // Update available upsell options based on selected routine
    this.updateUpsellOptions();
    // Clear selections that don't match the current routine
    this.clearInvalidSelections();
    // Update pricing displays based on selected routine
    this.updatePricingDisplays();
    // Update add to cart button availability
    this.updateAddToCartButtonAvailability();
  }
  handleSubscriptionSelection(event) {
    const subscriptionItem = event.currentTarget;
    // Prevent clicking on already selected item
    if (subscriptionItem.classList.contains("selected")) {
      return;
    }
    // Remove selected class from all subscription items
    this.subscriptionItems.forEach((item) => {
      item.classList.remove("selected");
    });
    // Add selected class to clicked item
    subscriptionItem.classList.add("selected");
    // Update selected subscription
    if (subscriptionItem.classList.contains("subscription-1-month")) {
      this.selectedSubscription = "subscription";
    } else if (subscriptionItem.classList.contains("one-time-purchase")) {
      this.selectedSubscription = "one-time";
    }
    // Update info box visibility with accordion behavior
    this.updateInfoBoxVisibility();
    // Update SVG icons based on selection
    this.updatePurchaseOptionSVGs();
  }
  updateInfoBoxVisibility() {
    const routineFeatures = document.querySelectorAll('.routine-features');
    routineFeatures.forEach(feature => {
      feature.classList.remove('active');
      feature.style.display = 'none';
    });
    const activeFeature = document.querySelector(`.routine-features[data-routine="${this.selectedRoutine}"]`);
    if (activeFeature) {
      activeFeature.style.display = 'block';
      activeFeature.classList.add('active');
    }
  }
  updateUpsellOptions() {
    // Always show both sections but disable individual buttons based on routine
    const allFlavorCards = document.querySelectorAll(".product-upsell .flavor-card");
    allFlavorCards.forEach((card) => {
      const button = card.querySelector(".add-flavor-button");
      if (!button) return;
      const buttonType = button.getAttribute("data-type");
      // Check if this flavor type should be disabled based on current routine
      const shouldDisable = (this.selectedRoutine === "am" && buttonType === "PM") || 
                           (this.selectedRoutine === "pm" && buttonType === "AM");
      if (shouldDisable) {
        card.classList.add("disabled");
        button.classList.add("disabled");
        button.disabled = true;
      } else {
        card.classList.remove("disabled");
        button.classList.remove("disabled");
        button.disabled = false;
      }
    });
    // Always show headers for both sections
    document.querySelectorAll(".product-upsell__header").forEach((header) => {
      header.style.display = "flex";
    });
  }
  clearInvalidSelections() {
    // Clear selections that don't match the current routine
    this.upsellButtons.forEach((button) => {
      const buttonType = button.getAttribute("data-type");
      const variantId = button.getAttribute("data-variant-id");
      const flavorCard = button.closest(".flavor-card");
      // If button is selected but doesn't match current routine, deselect it
      if (
        this.selectedUpsells.has(variantId) &&
        ((this.selectedRoutine === "am" && buttonType === "PM") || (this.selectedRoutine === "pm" && buttonType === "AM"))
      ) {
        this.selectedUpsells.delete(variantId);
        this.toggleButtonState(button, false);
        flavorCard.classList.remove("selected");
      }
    });
    // Update flavor states for both AM and PM after clearing invalid selections
    this.updateFlavorStates("AM");
    this.updateFlavorStates("PM");
  }
  updatePurchaseOptionSVGs() {
    const subscriptionSVG = document.querySelector(".subscription-svg");
    const oneTimeSVG = document.querySelector(".one-time-svg");
    if (!subscriptionSVG || !oneTimeSVG) return;
    if (this.selectedSubscription === "subscription") {
      // Subscription selected - show filled green circle for subscription, empty for one-time
      subscriptionSVG.innerHTML = `
        <circle cx="8.00002" cy="8.49995" r="4.8" fill="#008330"/>
        <circle cx="8.00002" cy="8.5" r="7.35" stroke="#008330" stroke-width="1.3"/>
      `;
      oneTimeSVG.innerHTML = `
        <circle cx="8" cy="8.5" r="7.3" stroke="#0D0C0C" stroke-width="1.4"/>
      `;
    } else {
      // One-time selected - show filled green circle for one-time, empty for subscription
      subscriptionSVG.innerHTML = `
        <circle cx="8.00002" cy="8.5" r="7.35" stroke="#0D0C0C" stroke-width="1.3"/>
      `;
      oneTimeSVG.innerHTML = `
        <circle cx="8" cy="8.5" r="4.8" fill="#008330"/>
        <circle cx="8" cy="8.5" r="7.3" stroke="#008330" stroke-width="1.4"/>
      `;
    }
  }
  updateAddToCartButtonAvailability() {
    const visibleSelectedFlavors = this.getVisibleSelectedFlavors();
    const hasFlavors = visibleSelectedFlavors.length > 0;
    document.dispatchEvent(new CustomEvent('flavors:changed', {
      detail: { hasFlavors, count: visibleSelectedFlavors.length }
    }));
    if (!this.customAddToCartButton) return;
    const buttonTextSpan = this.customAddToCartButton.querySelector(".custom-add-to-cart__text");
    const addToCartText = this.customAddToCartButton.dataset.addToCartText || "Add to cart";
    const selectFlavorsText = this.customAddToCartButton.dataset.selectFlavorsText || "Select flavors";
    if (!hasFlavors) {
      this.customAddToCartButton.setAttribute("disabled", "disabled");
      this.customAddToCartButton.classList.add("disabled", "custom-add-to-cart--disabled");
      this.customAddToCartButton.classList.remove("custom-add-to-cart--active");
      if (buttonTextSpan) buttonTextSpan.textContent = selectFlavorsText;
    } else {
      this.customAddToCartButton.removeAttribute("disabled");
      this.customAddToCartButton.classList.remove("disabled", "custom-add-to-cart--disabled");
      this.customAddToCartButton.classList.add("custom-add-to-cart--active");
      if (buttonTextSpan) buttonTextSpan.textContent = addToCartText;
    }
  }
  getVisibleSelectedFlavors() {
    // Get all selected flavors that are currently visible based on the routine
    const visibleSelectedFlavors = [];
    // Check both original buttons and quantity controls
    const allFlavorElements = document.querySelectorAll(".product-upsell .add-flavor-button, .product-upsell .flavor-quantity-controls");
    allFlavorElements.forEach((element) => {
      let variantId, buttonType, flavorCard;
      if (element.classList.contains("add-flavor-button")) {
        variantId = element.getAttribute("data-variant-id");
        buttonType = element.getAttribute("data-type");
        flavorCard = element.closest(".flavor-card");
      } else if (element.classList.contains("flavor-quantity-controls")) {
        // Get variant ID and type from the quantity controls element itself
        variantId = element.getAttribute("data-variant-id");
        buttonType = element.getAttribute("data-type");
        flavorCard = element.closest(".flavor-card");
      }
      if (!variantId || !buttonType) return;
      // Check if the flavor is selected and visible based on current routine
      if (this.selectedUpsells.has(variantId)) {
        // Check if the flavor type matches the current routine
        if (
          this.selectedRoutine === "am-pm" ||
          (this.selectedRoutine === "am" && buttonType === "AM") ||
          (this.selectedRoutine === "pm" && buttonType === "PM")
        ) {
          // Check if the flavor card is visible
          if (flavorCard && window.getComputedStyle(flavorCard).display !== "none") {
            const quantity = this.selectedUpsells.get(variantId);
            const flavorName = element.getAttribute("data-flavor") || "Unknown";
            visibleSelectedFlavors.push({
              variantId: variantId,
              quantity: quantity,
              flavorName: flavorName,
              type: buttonType,
            });
          }
        }
      }
    });
    return visibleSelectedFlavors;
  }
  handleUpsellButtonClick(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    const flavorCard = button.closest(".flavor-card");
    const buttonType = button.getAttribute("data-type");
    const flavorName = button.dataset.flavor;
    if (!variantId) return;
    // Check if the selected flavor is compatible with the current routine
    if ((this.selectedRoutine === "am" && buttonType === "PM") || (this.selectedRoutine === "pm" && buttonType === "AM")) {
      return;
    }
    // Check if already added
    if (button.getAttribute("data-added") === "true") {
      // Remove selection
      this.selectedUpsells.delete(variantId);
      this.toggleButtonState(button, false);
      flavorCard.classList.remove("selected");
      // Update flavor states for this type
      this.updateFlavorStates(buttonType);
    } else {
      // Clear any existing selection of the same type (AM or PM)
      this.clearSelectionsByType(buttonType);
      // Add new selection
      this.selectedUpsells.set(variantId, 1);
      this.toggleButtonState(button, true);
      flavorCard.classList.add("selected");
      // Update flavor states for this type (disable others)
      this.updateFlavorStates(buttonType);
    }
    // Update add to cart button availability
    this.updateAddToCartButtonAvailability();
  }
  toggleButtonState(button, isAdded) {
    const addIcon = button.querySelector(".button-icon-add");
    const addText = button.querySelector(".button-text");
    const addedText = button.querySelector(".button-text-added");
    if (isAdded) {
      button.setAttribute("data-added", "true");
      addIcon.style.display = "none";
      if (addText) addText.style.display = "none";
      addedText.style.display = "inline";
    } else {
      button.setAttribute("data-added", "false");
      addIcon.style.display = "flex";
      if (addText) addText.style.display = "inline-block";
      addedText.style.display = "none";
    }
  }
  clearSelectionsByType(buttonType) {
    // Clear all existing selections of the same type (AM or PM)
    const buttonsOfSameType = document.querySelectorAll(`[data-type="${buttonType}"].add-flavor-button`);
    buttonsOfSameType.forEach(btn => {
      if (btn.getAttribute("data-added") === "true") {
        const variantId = btn.getAttribute("data-variant-id");
        const flavorCard = btn.closest(".flavor-card");
        // Remove from selections
        this.selectedUpsells.delete(variantId);
        // Reset button state
        this.toggleButtonState(btn, false);
        // Remove selected class
        if (flavorCard) {
          flavorCard.classList.remove("selected");
        }
      }
    });
    // Enable all flavors of this type after clearing
    this.updateFlavorStates(buttonType);
  }
  updateFlavorStates(buttonType) {
    const buttonsOfSameType = document.querySelectorAll(`[data-type="${buttonType}"].add-flavor-button`);
    const hasSelection = Array.from(buttonsOfSameType).some(btn => btn.getAttribute("data-added") === "true");
    buttonsOfSameType.forEach(btn => {
      const flavorCard = btn.closest(".flavor-card");
      const isSelected = btn.getAttribute("data-added") === "true";
      if (hasSelection && !isSelected) {
        // Disable this flavor card
        flavorCard.classList.add("disabled");
      } else {
        // Enable this flavor card
        flavorCard.classList.remove("disabled");
      }
    });
  }
  handleQuantityChange(variantId, change, quantityDisplay) {
    const currentQuantity = this.selectedUpsells.get(variantId) || 0;
    const newQuantity = Math.max(0, currentQuantity + change);
    if (newQuantity === 0) {
      // Remove from selection and restore original button
      this.selectedUpsells.delete(variantId);
      const flavorCard = document.querySelector(`[data-variant-id="${variantId}"]`).closest(".flavor-card");
      const quantityControls = flavorCard.querySelector(".flavor-quantity-controls");
      if (quantityControls) {
        const originalButton = document.createElement("button");
        originalButton.type = "button";
        originalButton.className = "add-flavor-button";
        originalButton.textContent = "Add +";
        originalButton.setAttribute("data-variant-id", variantId);
        originalButton.setAttribute("data-type", document.querySelector(`[data-variant-id="${variantId}"]`).getAttribute("data-type"));
        originalButton.setAttribute("data-flavor", document.querySelector(`[data-variant-id="${variantId}"]`).getAttribute("data-flavor"));
        originalButton.addEventListener("click", this.handleUpsellButtonClick.bind(this));
        quantityControls.parentNode.replaceChild(originalButton, quantityControls);
        flavorCard.classList.remove("selected");
      }
    } else {
      // Update quantity
      this.selectedUpsells.set(variantId, newQuantity);
      quantityDisplay.textContent = newQuantity;
    }
    // Update button states
    const decrementBtn = quantityDisplay.parentNode.querySelector(".decrement-btn");
    if (decrementBtn) {
      decrementBtn.disabled = newQuantity <= 0;
    }
    // Update add to cart button availability
    this.updateAddToCartButtonAvailability();
  }
  initCustomButtonListener() {
    if (!this.customAddToCartButton) {
      return;
    }
    let clickTimeout = null;
    this.customAddToCartButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.isAddingToCart) {
        return;
      }
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
      clickTimeout = setTimeout(async () => {
        const originalScrollTo = window.scrollTo;
        const originalScrollIntoView = Element.prototype.scrollIntoView;
        window.scrollTo = function() {};
        Element.prototype.scrollIntoView = function() {};
        try {
          const visibleFlavors = this.getVisibleSelectedFlavors();
          if (visibleFlavors.length > 0 || this.selectedRoutine !== "") {
            await this.addProductsToCart();
          } else {
            await this.addMainProductOnly();
          }
        } finally {
          setTimeout(() => {
            window.scrollTo = originalScrollTo;
            Element.prototype.scrollIntoView = originalScrollIntoView;
          }, 100);
        }
      }, 300);
    });
  }
  async addProductsToCart() {
    if (this.isAddingToCart) return;
    try {
      this.isAddingToCart = true;
      this.updateAddToCartButtonState(true);
      if (!this.mainAddToCartForm) {
        return;
      }
      const items = [];
      const visibleFlavors = this.getVisibleSelectedFlavors();
      visibleFlavors.forEach(flavor => {
        const item = {
          id: parseInt(flavor.variantId, 10),
          quantity: flavor.quantity || 1,
          properties: {
            "Routine": flavor.type,
            "Flavor": flavor.flavorName,
            "Purchase Type": this.selectedSubscription === "subscription" ? "AutoShip & Save" : "One Time Purchase",
          },
        };
        if (this.selectedSubscription === "subscription") {
          let sellingPlanId;
          if (this.selectedRoutine === "am-pm" && window.UPSELL_SELLING_PLANS?.AM_PM) {
            sellingPlanId = window.UPSELL_SELLING_PLANS.AM_PM;
          } else {
            sellingPlanId = flavor.type === "AM" ? window.UPSELL_SELLING_PLANS?.AM : window.UPSELL_SELLING_PLANS?.PM;
          }
          if (sellingPlanId) {
            item.selling_plan = parseInt(sellingPlanId, 10);
          }
        }
        items.push(item);
      });
      this.selectedAdditionalProducts.forEach((product, variantId) => {
        items.push({
          id: parseInt(variantId, 10),
          quantity: product.quantity,
          properties: {
            "Upsell Product": "Additional Product",
            "Purchase Type": "One Time Purchase",
          },
        });
      });
      if (items.length === 0) {
        throw new Error("No items to add to cart");
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        const errorText = await response.text();
        let errorMsg = "Failed to add products to cart";
        try {
          const errorData = JSON.parse(errorText);
          errorMsg = errorData.description || errorData.message || errorMsg;
        } catch {
          errorMsg = errorText || errorMsg;
        }
        throw new Error(errorMsg);
      }
      const cartData = await response.json();
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'custom-product-form',
          cartData: cartData,
        });
      }
      await this.openCartDrawer();
      this.showAddToCartSuccess();
    } catch (error) {
      this.showAddToCartError(error);
    } finally {
      this.isAddingToCart = false;
      this.updateAddToCartButtonState(false);
    }
  }
  async addMainProductOnly() {
    try {
      this.isAddingToCart = true;
      this.updateAddToCartButtonState(true);
      const formData = new FormData(this.mainAddToCartForm);
      const mainVariantId = formData.get("id");
      const mainQuantity = formData.get("quantity") || 1;
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: mainVariantId,
              quantity: parseInt(mainQuantity),
            },
          ],
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to add product to cart");
      }
      // Get cart data and publish update event
      const cartData = await response.json();
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'custom-product-form',
          cartData: cartData,
        });
      }
      // Open cart drawer instead of redirecting
      await this.openCartDrawer();
    } catch (error) {
      this.showAddToCartError(error);
    } finally {
      this.isAddingToCart = false;
      this.updateAddToCartButtonState(false);
    }
  }
  updateAddToCartButtonState(isLoading) {
    if (!this.customAddToCartButton) return;
    const buttonTextSpan = this.customAddToCartButton.querySelector(".custom-add-to-cart__text");
    if (isLoading) {
      this.customAddToCartButton.setAttribute("disabled", "disabled");
      this.customAddToCartButton.classList.add("loading");
      if (buttonTextSpan) buttonTextSpan.textContent = "Adding...";
    } else {
      this.customAddToCartButton.classList.remove("loading");
      this.updateAddToCartButtonAvailability();
    }
  }
  showAddToCartSuccess() {
    const event = new CustomEvent("product:added", {
      detail: {
        message: "Products added to cart successfully!",
      },
    });
    document.documentElement.dispatchEvent(event);
    this.resetUpsellSelections();
  }
  resetUpsellSelections() {
    this.selectedUpsells.clear();
    this.upsellButtons.forEach((button) => {
      this.toggleButtonState(button, false);
      const flavorCard = button.closest(".flavor-card");
      if (flavorCard) {
        flavorCard.classList.remove("selected");
      }
    });
    this.updateFlavorStates("AM");
    this.updateFlavorStates("PM");
    this.selectedAdditionalProducts.clear();
    const additionalCards = document.querySelectorAll(".flavor-card.additional-product-card");
    additionalCards.forEach((card) => {
      const addButton = card.querySelector(".add-additional-product-button");
      const quantityControls = card.querySelector(".quantity-controls");
      if (addButton) {
        addButton.style.display = "flex";
        addButton.setAttribute("data-added", "false");
      }
      if (quantityControls) {
        quantityControls.style.display = "none";
        const quantityDisplay = quantityControls.querySelector(".quantity-display");
        if (quantityDisplay) {
          quantityDisplay.textContent = "1";
        }
      }
      card.classList.remove("selected");
    });
    this.updateAddToCartButtonAvailability();
  }
  showAddToCartError(error) {
    // Show error message
    const event = new CustomEvent("product:error", {
      detail: {
        message: "Failed to add products to cart. Please try again.",
      },
    });
    document.documentElement.dispatchEvent(event);
  }
  async openCartDrawer() {
    await new Promise(resolve => setTimeout(resolve, 100));
    
    let cartDrawer = document.querySelector('cart-drawer.gradient.smart-cart--enabled.rebuy-cart-visible') 
      || document.querySelector('cart-drawer.smart-cart--enabled') 
      || document.querySelector('cart-drawer.rebuy-cart-visible')
      || document.querySelector('cart-drawer');
    
    if (!cartDrawer) {
      await new Promise(resolve => setTimeout(resolve, 200));
      cartDrawer = document.querySelector('cart-drawer');
    }
    
    if (cartDrawer) {
      const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
      if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
        await cartDrawerItems.onCartUpdate();
      }
      
      if (typeof window.Rebuy !== 'undefined' && typeof window.Rebuy.cart === 'object' && typeof window.Rebuy.cart.open === 'function') {
        window.Rebuy.cart.open();
      } else if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
      
      const cartUpdateEvent = new CustomEvent('cart:update', { bubbles: true });
      document.dispatchEvent(cartUpdateEvent);
    }
  }
  handleFlavorCardClick(card) {
    const imagesData = card.getAttribute("data-images");
    if (!imagesData) return;
    let images;
    try {
      images = JSON.parse(imagesData);
    } catch {
      return;
    }
    if (Array.isArray(images) && images.length) {
      // Find all main gallery images
      const galleryImages = document.querySelectorAll(".product__media.media.media--transparent > img");
      if (galleryImages.length === images.length) {
        galleryImages.forEach((img, idx) => {
          img.src = images[idx];
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
        });
      }
      const thumbnailImages = document.querySelectorAll(".thumbnail-list .thumbnail img");
      if (thumbnailImages.length === images.length) {
        thumbnailImages.forEach((img, idx) => {
          img.src = images[idx];
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
        });
      }
    }
  }
  initFlavorGalleryModal() {
    this.galleryModal = document.querySelector("[id^='flavor-gallery-modal-']");
    if (!this.galleryModal) return;
    this.galleryModalContent = this.galleryModal.querySelector(".flavor-gallery-modal__content");
    this.galleryModalClose = this.galleryModal.querySelector(".flavor-gallery-modal__close");
    this.galleryModalOverlay = this.galleryModal.querySelector(".flavor-gallery-modal__overlay");
    this.galleryModalTitle = this.galleryModal.querySelector(".flavor-gallery-modal__title");
    this.galleryModalMediaList = this.galleryModal.querySelector(".flavor-gallery-modal__media-list");
    this.galleryModalThumbnails = this.galleryModal.querySelector(".flavor-gallery-modal__thumbnails");
    this.galleryModalPrev = this.galleryModal.querySelector(".slider-button--prev");
    this.galleryModalNext = this.galleryModal.querySelector(".slider-button--next");
    this.galleryModalCurrent = this.galleryModal.querySelector(".flavor-gallery-modal__current");
    this.galleryModalTotal = this.galleryModal.querySelector(".flavor-gallery-modal__total");
    this.currentGalleryIndex = 0;
    this.currentGalleryImages = [];
    this.isScrolling = false;
    const flavorImageTriggers = document.querySelectorAll("[data-flavor-gallery-trigger]");
    flavorImageTriggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openFlavorGalleryModal(trigger);
      });
    });
    const productGalleryTriggers = document.querySelectorAll("[data-product-gallery-trigger]");
    productGalleryTriggers.forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openProductGalleryModal(trigger);
      });
    });
    if (this.galleryModalClose) {
      this.galleryModalClose.addEventListener("click", () => this.closeFlavorGalleryModal());
    }
    if (this.galleryModal) {
      this.galleryModal.addEventListener("click", (e) => {
        if (e.target === this.galleryModal) {
          this.closeFlavorGalleryModal();
        }
      });
    }
    if (this.galleryModalPrev) {
      this.galleryModalPrev.addEventListener("click", () => this.prevGalleryImage());
    }
    if (this.galleryModalNext) {
      this.galleryModalNext.addEventListener("click", () => this.nextGalleryImage());
    }
    document.addEventListener("keydown", (e) => {
      if (this.galleryModal && this.galleryModal.style.display !== "none") {
        switch (e.key) {
          case "Escape":
            this.closeFlavorGalleryModal();
            break;
          case "ArrowLeft":
            this.prevGalleryImage();
            break;
          case "ArrowRight":
            this.nextGalleryImage();
            break;
        }
      }
    });
    if (this.galleryModalMediaList) {
      this.galleryModalMediaList.addEventListener("wheel", this.handleGalleryWheel.bind(this), { passive: false });
      this.galleryModalMediaList.addEventListener("scroll", this.handleGalleryScroll.bind(this));
    }
  }
  openFlavorGalleryModal(trigger) {
    const flavorName = trigger.getAttribute("data-flavor-name");
    const flavorCard = trigger.closest(".flavor-card");
    if (!flavorCard || !this.galleryModal) return;
    const imagesData = flavorCard.getAttribute("data-images");
    if (this.galleryModalTitle) {
      this.galleryModalTitle.textContent = flavorName || "Flavor Gallery";
    }
    let images = [];
    if (imagesData) {
      try {
        images = JSON.parse(imagesData);
      } catch {
        images = [];
      }
    }
    if (!Array.isArray(images) || images.length === 0) {
      if (this.galleryModalMediaList) {
        this.galleryModalMediaList.innerHTML = '<li class="flavor-gallery-modal__media-item slider__slide" style="display: flex; align-items: center; justify-content: center; height: 400px;"><div style="text-align: center; color: #666;">No images available for this flavor.</div></li>';
      }
      if (this.galleryModalThumbnails) {
        this.galleryModalThumbnails.innerHTML = '';
      }
      if (this.galleryModalPrev) this.galleryModalPrev.style.display = "none";
      if (this.galleryModalNext) this.galleryModalNext.style.display = "none";
      this.galleryModal.style.display = "block";
      document.body.style.overflow = "hidden";
      if (this.galleryModalContent) {
        this.galleryModalContent.focus();
      }
      return;
    }
    // Reset to first image for each new gallery
    this.currentGalleryImages = images;
    this.currentGalleryIndex = 0;
    // Build images in media list
    this.buildGalleryMediaList();
    // Build thumbnails
    this.buildGalleryThumbnails();
    // Update navigation
    this.updateGalleryNavigation();
    // Update counter
    this.updateGalleryCounter();
    // Show modal
    this.galleryModal.style.display = "block";
    document.body.style.overflow = "hidden";
    // Focus on modal for accessibility
    if (this.galleryModalContent) {
      this.galleryModalContent.focus();
    }
  }
  closeFlavorGalleryModal() {
    if (!this.galleryModal) return;
    this.galleryModal.style.display = "none";
    document.body.style.overflow = "";
    this.currentGalleryImages = [];
    this.currentGalleryIndex = 0;
  }
  openProductGalleryModal(trigger) {
    const productCard = trigger.closest(".additional-product-card");
    if (!productCard || !this.galleryModal) return;
    const imagesData = productCard.getAttribute("data-images");
    const productTitle = productCard.querySelector(".flavor-name")?.textContent || "Product Gallery";
    if (this.galleryModalTitle) {
      this.galleryModalTitle.textContent = productTitle;
    }
    let images = [];
    if (imagesData) {
      try {
        images = JSON.parse(imagesData);
      } catch {
        images = [];
      }
    }
    if (!Array.isArray(images) || images.length === 0) {
      if (this.galleryModalMediaList) {
        this.galleryModalMediaList.innerHTML = '<li class="flavor-gallery-modal__media-item slider__slide" style="display: flex; align-items: center; justify-content: center; height: 400px;"><div style="text-align: center; color: #666;">No images available for this product.</div></li>';
      }
      if (this.galleryModalThumbnails) {
        this.galleryModalThumbnails.innerHTML = '';
      }
      if (this.galleryModalPrev) this.galleryModalPrev.style.display = "none";
      if (this.galleryModalNext) this.galleryModalNext.style.display = "none";
      this.galleryModal.style.display = "block";
      document.body.style.overflow = "hidden";
      if (this.galleryModalContent) {
        this.galleryModalContent.focus();
      }
      return;
    }
    this.currentGalleryImages = images;
    this.currentGalleryIndex = 0;
    this.buildGalleryMediaList();
    this.buildGalleryThumbnails();
    this.updateGalleryNavigation();
    this.updateGalleryCounter();
    this.galleryModal.style.display = "block";
    document.body.style.overflow = "hidden";
    if (this.galleryModalContent) {
      this.galleryModalContent.focus();
    }
  }
  buildGalleryMediaList() {
    if (!this.galleryModalMediaList) return;
    this.galleryModalMediaList.innerHTML = "";
    this.currentGalleryImages.forEach((imageSrc, index) => {
      const listItem = document.createElement("li");
      listItem.className = "flavor-gallery-modal__media-item slider__slide";
      listItem.innerHTML = `
        <img src="${imageSrc}" alt="Flavor image ${index + 1}" loading="${index === 0 ? 'eager' : 'lazy'}">
      `;
      this.galleryModalMediaList.appendChild(listItem);
    });
    this.galleryModalMediaList.scrollTo({ left: 0, behavior: 'auto' });
    // Ensure DOM is rendered before setting active state; double-rAF to stabilize measurements
    setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.goToGalleryImage(0));
      });
    }, 50);
  }
  buildGalleryThumbnails() {
    if (!this.galleryModalThumbnails) return;
    this.galleryModalThumbnails.innerHTML = "";
    this.currentGalleryImages.forEach((imageSrc, index) => {
      const listItem = document.createElement("li");
      listItem.className = "slider__slide";
      const thumbnailButton = document.createElement("button");
      thumbnailButton.className = `flavor-gallery-modal__thumbnail ${index === 0 ? 'active' : ''}`;
      thumbnailButton.type = "button";
      thumbnailButton.innerHTML = `
        <img src="${imageSrc}" alt="Thumbnail ${index + 1}" loading="lazy">
      `;
      thumbnailButton.addEventListener("click", () => this.goToGalleryImage(index));
      listItem.appendChild(thumbnailButton);
      this.galleryModalThumbnails.appendChild(listItem);
    });
  }
  updateGalleryNavigation() {
    if (!this.galleryModalPrev || !this.galleryModalNext) return;
    this.galleryModalPrev.style.display = this.currentGalleryImages.length > 1 ? "flex" : "none";
    this.galleryModalNext.style.display = this.currentGalleryImages.length > 1 ? "flex" : "none";
  }
  updateGalleryCounter() {
    if (this.galleryModalCurrent) {
      this.galleryModalCurrent.textContent = this.currentGalleryIndex + 1;
    }
    if (this.galleryModalTotal) {
      this.galleryModalTotal.textContent = this.currentGalleryImages.length;
    }
  }
  goToGalleryImage(index) {
    if (index < 0 || index >= this.currentGalleryImages.length) return;
    this.currentGalleryIndex = index;
    this.isScrolling = true;
    if (this.galleryModalMediaList) {
      const mediaItems = this.galleryModalMediaList.querySelectorAll('.flavor-gallery-modal__media-item');
      const containerWidth = this.galleryModalMediaList.clientWidth;
      const containerStyle = window.getComputedStyle(this.galleryModalMediaList);
      const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
      let targetLeft = 0;
      if (mediaItems[index]) {
        const slide = mediaItems[index];
        const slideLeft = slide.offsetLeft - paddingLeft;
        const slideCenter = slideLeft + (slide.offsetWidth / 2);
        const containerCenter = containerWidth / 2;
        targetLeft = Math.max(0, slideCenter - containerCenter);
        const maxLeft = this.galleryModalMediaList.scrollWidth - containerWidth;
        targetLeft = Math.min(targetLeft, Math.max(0, maxLeft));
      }
      // If already very close, do a tiny smooth adjust; else smooth to targetLeft
      const currentLeft = this.galleryModalMediaList.scrollLeft;
      const delta = Math.abs(currentLeft - targetLeft);
      this.galleryModalMediaList.scrollTo({
        left: targetLeft,
        behavior: delta < 6 ? 'auto' : 'smooth'
      });
    }
    const thumbnails = this.galleryModalThumbnails?.querySelectorAll(".flavor-gallery-modal__thumbnail");
    thumbnails?.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === index);
    });
    this.updateGalleryCounter();
    setTimeout(() => {
      this.isScrolling = false;
    }, 500);
  }
  prevGalleryImage() {
    const newIndex = this.currentGalleryIndex > 0 
      ? this.currentGalleryIndex - 1 
      : this.currentGalleryImages.length - 1;
    this.goToGalleryImage(newIndex);
  }
  nextGalleryImage() {
    const newIndex = this.currentGalleryIndex < this.currentGalleryImages.length - 1 
      ? this.currentGalleryIndex + 1 
      : 0;
    this.goToGalleryImage(newIndex);
  }
  handleGalleryWheel(event) {
    if (!this.galleryModalMediaList || this.isScrolling || this.isWheelScrolling) return;
    event.preventDefault();
    event.stopPropagation();
    const now = Date.now();
    if (now - this.lastScrollTime < this.scrollThreshold) {
      return;
    }
    const deltaX = event.deltaX;
    const deltaY = event.deltaY;
    const totalDelta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;
    if (Math.abs(totalDelta) > 5) {
      this.isWheelScrolling = true;
      this.lastScrollTime = now;
      if (totalDelta > 0) {
        this.nextGalleryImage();
      } else {
        this.prevGalleryImage();
      }
      setTimeout(() => {
        // Ensure final snap to the exact center of the current slide
        this.goToGalleryImage(this.currentGalleryIndex);
        this.isWheelScrolling = false;
      }, this.scrollThreshold);
    }
  }
  handleGalleryScroll() {
    if (!this.galleryModalMediaList || this.isScrolling || this.isWheelScrolling) return;
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      if (this.isWheelScrolling) return;
      const newIndex = this.getCurrentImageIndexFromScroll();
      if (newIndex !== this.currentGalleryIndex) {
        this.currentGalleryIndex = newIndex;
        this.updateGalleryThumbnailsAndCounter();
      }
    }, 150);
  }
  getCurrentImageIndexFromScroll() {
    if (!this.galleryModalMediaList) return 0;
    const mediaItems = this.galleryModalMediaList.querySelectorAll('.flavor-gallery-modal__media-item');
    if (!mediaItems.length) return 0;
    const containerScrollLeft = this.galleryModalMediaList.scrollLeft;
    const containerCenter = containerScrollLeft + (this.galleryModalMediaList.clientWidth / 2);
    let closestIndex = 0;
    let smallestDistance = Infinity;
    mediaItems.forEach((item, idx) => {
      const slideCenter = item.offsetLeft + (item.offsetWidth / 2);
      const distance = Math.abs(slideCenter - containerCenter);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestIndex = idx;
      }
    });
    return closestIndex;
  }
  updateGalleryThumbnailsAndCounter() {
    const thumbnails = this.galleryModalThumbnails?.querySelectorAll(".flavor-gallery-modal__thumbnail");
    thumbnails?.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === this.currentGalleryIndex);
    });
    this.updateGalleryCounter();
  }
  initAdditionalUpsellProducts() {
    this.additionalUpsellButtons.forEach((button) => {
      button.addEventListener("click", this.handleAdditionalUpsellClick.bind(this));
    });
    // Initialize quantity controls
    const quantityControls = document.querySelectorAll(".quantity-controls");
    quantityControls.forEach((control) => {
      const decreaseBtn = control.querySelector(".quantity-decrease");
      const increaseBtn = control.querySelector(".quantity-increase");
      if (decreaseBtn) {
        decreaseBtn.addEventListener("click", this.handleQuantityDecrease.bind(this));
      }
      if (increaseBtn) {
        increaseBtn.addEventListener("click", this.handleQuantityIncrease.bind(this));
      }
    });
  }
  handleAdditionalUpsellClick(event) {
    const button = event.currentTarget;
    const card = button.closest(".flavor-card.additional-product-card");
    const variantId = button.getAttribute("data-variant-id");
    const productId = button.getAttribute("data-product-id");
    const isAdded = button.getAttribute("data-added") === "true";
    if (!isAdded) {
      // Add product with quantity 1
      this.selectedAdditionalProducts.set(variantId, {
        productId: productId,
        quantity: 1
      });
      // Hide the add button and show quantity controls
      button.style.display = "none";
      const quantityControls = card.querySelector(".quantity-controls");
      if (quantityControls) {
        quantityControls.style.display = "flex";
        const quantityDisplay = quantityControls.querySelector(".quantity-display");
        if (quantityDisplay) {
          quantityDisplay.textContent = "1";
        }
      }
      button.setAttribute("data-added", "true");
      card.classList.add("selected");
    }
  }
  handleQuantityDecrease(event) {
    const button = event.currentTarget;
    const card = button.closest(".flavor-card.additional-product-card");
    const variantId = card.getAttribute("data-variant-id");
    const quantityDisplay = card.querySelector(".quantity-display");
    const addButton = card.querySelector(".add-additional-product-button");
    const quantityControls = card.querySelector(".quantity-controls");
    if (this.selectedAdditionalProducts.has(variantId)) {
      const product = this.selectedAdditionalProducts.get(variantId);
      const newQuantity = Math.max(0, product.quantity - 1);
      if (newQuantity === 0) {
        // Remove product from selection
        this.selectedAdditionalProducts.delete(variantId);
        // Hide quantity controls and show add button
        if (quantityControls) quantityControls.style.display = "none";
        if (addButton) {
          addButton.style.display = "flex";
          addButton.setAttribute("data-added", "false");
        }
        card.classList.remove("selected");
      } else {
        // Update quantity
        product.quantity = newQuantity;
        this.selectedAdditionalProducts.set(variantId, product);
        if (quantityDisplay) {
          quantityDisplay.textContent = newQuantity.toString();
        }
      }
    }
  }
  handleQuantityIncrease(event) {
    const button = event.currentTarget;
    const card = button.closest(".flavor-card.additional-product-card");
    const variantId = card.getAttribute("data-variant-id");
    const productId = card.getAttribute("data-product-id");
    const quantityDisplay = card.querySelector(".quantity-display");
    if (this.selectedAdditionalProducts.has(variantId)) {
      const product = this.selectedAdditionalProducts.get(variantId);
      const newQuantity = product.quantity + 1;
      // Update quantity
      product.quantity = newQuantity;
      this.selectedAdditionalProducts.set(variantId, product);
      if (quantityDisplay) {
        quantityDisplay.textContent = newQuantity.toString();
      }
    } else {
      // This shouldn't happen, but handle it just in case
      this.selectedAdditionalProducts.set(variantId, {
        productId: productId,
        quantity: 1
      });
      if (quantityDisplay) {
        quantityDisplay.textContent = "1";
      }
    }
  }
  updatePricingDisplays() {
    const routinePriceOptions = document.querySelectorAll('.routine-price-option');
    const routineTotalOptions = document.querySelectorAll('.routine-total-option');
    const routineRibbons = document.querySelectorAll('.routine-ribbon');
    const routineFeatures = document.querySelectorAll('.routine-features');
    routinePriceOptions.forEach(option => option.style.display = 'none');
    routineTotalOptions.forEach(option => option.style.display = 'none');
    routineRibbons.forEach(option => option.style.display = 'none');
    routineFeatures.forEach(option => {
      option.style.display = 'none';
      option.classList.remove('active');
    });
    const selectedRoutine = this.selectedRoutine;
    const elementsToShow = document.querySelectorAll(`[data-routine="${selectedRoutine}"]`);
    elementsToShow.forEach(option => {
      option.style.display = 'block';
      if (option.classList.contains('routine-features')) {
        option.classList.add('active');
      }
    });
  }
}
// Initialize on DOMContentLoaded or immediately if already loaded
function initializeProductUpsell() {
  if (window.productUpsellInstance) {
    if (window.productUpsellInstance.initialized) {
      return;
    }
    window.productUpsellInstance.init();
    window.productUpsellInstance.initialized = true;
    return;
  }
  window.productUpsellInstance = new ProductUpsell();
  window.productUpsellInstance.init();
  window.productUpsellInstance.initialized = true;
}
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", function() {
    initializeProductUpsell();
  });
} else {
  setTimeout(function() {
    initializeProductUpsell();
  }, 0);
}

